import React from 'react'
import { SubPageBreadCrumbs } from 'Components/BreadCrumbs'
import ButtonCard from 'Components/ButtonCard'
import User from 'Hooks/user'

const ProcurementPage = () => {
    const { userRoles } = User();
    const isFinanceOrQC = userRoles.includes(8) || userRoles.includes(9);

    return (
        <div>
            <SubPageBreadCrumbs />
            <div style={{ display: 'flex' }} >
                {!isFinanceOrQC && <>
                    <ButtonCard link='/procurement/species-database' title={'Species Database'} blue />
                    <ButtonCard link='/procurement/product-list' title={'Product List'} blue />
                    <ButtonCard link='/procurement/collection-points' title={'Collection Points'} blue />
                    <ButtonCard link='/procurement/auction' title={'Auction Systems'} blue />
                    <ButtonCard link='/procurement/direct-sales/offers' title={'Direct Sales'} blue />
                    <ButtonCard link='/procurement/purchase-orders/data' title={'Purchase Orders'} blue />
                </>}
                <ButtonCard link={isFinanceOrQC ? '/procurement/vendor-payments/final-approval' : '/procurement/vendor-payments'} title={'Vendor Payments'} blue />
            </div>
        </div>
    )
}

ProcurementPage.propTypes = {}

export default ProcurementPage
